import { sendToApi } from 'api/client'
import { ExternalIntegration } from './ExternalIntegrationsClient'

export interface WordPressIntegration {
  id: number
  provider: string
  created_at: string
  updated_at: string
  username: string
  url: string
}

type CreateIntegrationParams = {
  url: string
  username: string
  password: string
  switch_from_integration_id?: number
}

export type WordPressPost = {
  id: number
  title: string
  status: 'publish' | 'draft'
  link: string
}

export const WordPressClient = {
  createIntegration: async ({ workspaceId, params }: { workspaceId: number; params: CreateIntegrationParams }) => {
    const res = await sendToApi<{ external_integration: ExternalIntegration }>(
      `/w/${workspaceId}/word_press/integration`,
      {
        body: params,
        method: 'post',
      },
    )

    if (res.type === 'error') {
      throw new Error(
        res.data?.error || 'An unknown error occurred. Our team has been notified and we are looking into it.',
      )
    }

    return res
  },
  getIntegration: async ({ workspaceId, id }: { workspaceId: number; id: number }) => {
    const res = await sendToApi<{ external_integration: WordPressIntegration }>(
      `/w/${workspaceId}/word_press/integration?id=${id}`,
      {
        method: 'get',
      },
    )

    if (res.type === 'error') {
      throw new Error(res.statusText || 'API Error')
    }

    return res
  },
  export: async ({
    workspaceId,
    articleKey,
    status,
    externalIntegrationId,
  }: {
    workspaceId: number
    articleKey: string
    status: 'publish' | 'draft'
    externalIntegrationId: number
  }) => {
    const res = await sendToApi<{ post: WordPressPost }>(`/w/${workspaceId}/word_press/exports`, {
      body: { status, article_key: articleKey, external_integration_id: externalIntegrationId },
      method: 'post',
    })

    if (res.type === 'error') {
      throw new Error(res.statusText || 'API Error')
    }

    return res
  },
}
